import axios from "axios";

const state = {
  availableDates: [],
  checkupReports: [],
};

const actions = {
  getAvailableDates: (context, departmentId) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        url:
          context.rootGetters.baseUrl +
          "report/available-dates/" +
          departmentId,
      })
        .then((response) => {
          const dates = response.data.data;
          context.commit("AVAILABLE_DATES_UPDATE", dates);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  resetAvailableDates: (context) => {
    context.commit("AVAILABLE_DATES_RESET");
  },
  getCheckupReports: (context, payload) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: context.rootGetters.baseUrl + "report",
        data: {
          department_id: payload.departmentId,
          date: payload.date,
        },
      })
        .then((response) => {
          const reports = response.data.data;
          context.commit("REPORTS_UPDATE", reports);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  resetCheckupReports: (context) => {
    context.commit("REPORTS_RESET");
  },
};

const mutations = {
  AVAILABLE_DATES_UPDATE: (state, dates) => {
    state.availableDates = dates;
  },
  AVAILABLE_DATES_RESET: (state) => {
    state.availableDates = [];
  },
  REPORTS_UPDATE: (state, reports) => {
    state.checkupReports = reports;
  },
  REPORTS_RESET: (state) => {
    state.checkupReports = [];
  },
};

const getters = {
  availableDates: (state) => state.availableDates,
  checkupReports: (state) => state.checkupReports,
};

export default {
  state: state,
  getters,
  actions,
  mutations,
};
